export default __webpack_public_path__ + "static/media/member-2.ceab5dbd.png";